export default "__VITE_ASSET__M1m1Av2L__"